(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); }, $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var post = function (url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); });
  };
  var count = function (n) { var el = $('#lxCount'); if (el) el.textContent = n; };

  $$('[data-lx-scroll]').forEach(function (a) { a.addEventListener('click', function (e) { var t = $(a.getAttribute('href')); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); } }); });

  // ---------- product ----------
  var root = $('[data-lx-product]'), dataEl = $('#lxData');
  if (root && dataEl) {
    var p = JSON.parse(dataEl.textContent), form = $('#lxForm'), idIn = $('#lxVar'), qIn = $('#lxQty');
    var chosen = {}; $$('.lx-opt').forEach(function (fs) { var b = $('[aria-pressed=true]', fs); chosen[+fs.dataset.opt] = b ? b.dataset.v : null; });
    var find = function () { return p.variants.filter(function (v) { return v.options.every(function (o, i) { return !chosen.hasOwnProperty(i) || chosen[i] === o; }); })[0]; };
    var qty = function () { var n = parseInt(qIn.value, 10); return n > 0 ? Math.min(n, 10) : 1; };
    function showPhoto(id) {
      var fig = $('.lx-gal__fig[data-media="' + id + '"]'); if (!fig) return;
      $$('.lx-gal__fig').forEach(function (f) { f.classList.toggle('is-on', f === fig); });
      $$('.lx-gal__t').forEach(function (t) { t.classList.toggle('is-on', t.dataset.thumb === String(id)); });
    }
    function sync() {
      var n = qty(); qIn.value = n; $('#lxMinus').disabled = n <= 1; $('#lxPlus').disabled = n >= 10;
      var v = find(); if (!v) return;
      idIn.value = v.id; $('#lxPrice').textContent = money(v.price);
      var was = $('#lxWas'), sv = $('#lxSave'), on = v.compare_at_price && v.compare_at_price > v.price;
      if (was) { was.hidden = !on; was.textContent = on ? money(v.compare_at_price) : ''; }
      if (sv) { sv.hidden = !on; sv.textContent = on ? 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : ''; }
      var add = $('#lxAdd'), now = $('#lxNow'); add.disabled = now.disabled = !v.available; add.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (window.history.replaceState) window.history.replaceState({}, '', location.pathname + '?variant=' + v.id);
    }
    form.addEventListener('click', function (e) {
      var b = e.target.closest('.lx-chip'); if (!b) return;
      var fs = b.closest('.lx-opt'); chosen[+fs.dataset.opt] = b.dataset.v;
      $$('.lx-chip', fs).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      $('[data-opt-val]', fs).textContent = b.dataset.v;
      var v = find(); if (v && v.featured_media) showPhoto(v.featured_media.id);
      sync();
    });
    $('#lxMinus').addEventListener('click', function () { qIn.value = qty() - 1; sync(); });
    $('#lxPlus').addEventListener('click', function () { qIn.value = qty() + 1; sync(); });
    qIn.addEventListener('change', sync);
    $$('.lx-gal__t').forEach(function (t) { t.addEventListener('click', function () { showPhoto(t.dataset.thumb); }); });
    var note = $('#lxNote'), noteT;
    var say = function (t) { note.textContent = t; note.classList.add('on'); clearTimeout(noteT); noteT = setTimeout(function () { note.classList.remove('on'); }, 3200); };
    form.addEventListener('submit', function (e) {
      e.preventDefault(); var btn = $('#lxAdd'); btn.setAttribute('aria-busy', 'true');
      post('/cart/add.js', { items: [{ id: +idIn.value, quantity: qty() }] })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (c) { count(c.item_count); say('Added to your bag. '); var l = document.createElement('a'); l.href = '/cart'; l.textContent = 'View bag'; note.appendChild(l); })
        .catch(function (er) { say(er.message); }).then(function () { btn.removeAttribute('aria-busy'); });
    });
    $('#lxNow').addEventListener('click', function () {
      var btn = this; btn.setAttribute('aria-busy', 'true');
      post('/cart/add.js', { items: [{ id: +idIn.value, quantity: qty() }] })
        .then(function () { location.href = '/checkout'; })
        .catch(function (er) { btn.removeAttribute('aria-busy'); say(er.message); });
    });
    var first = find(); if (first && first.featured_media) showPhoto(first.featured_media.id);
    sync();
  }

  // ---------- cart ----------
  $$('[data-lx-chg]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      post('/cart/change.js', { id: b.dataset.lxChg, quantity: +b.dataset.q }).then(function () { location.reload(); }).catch(function () { b.disabled = false; });
    });
  });
})();
